import { Button, Input } from "antd";
import React, { useState } from "react";
import axios from "axios";
const { TextArea } = Input;

const parseCurl = (curlCommand) => {
    const urlRegex = /curl\s+'([^']+)'/;
    const headersRegex = /-H\s+'([^:]+):\s*([^']+)'/g;
    const dataRegex = /(--data-raw|-d)\s+'([^']+)'/;
  
    const urlMatch = curlCommand.match(urlRegex);
    const url = urlMatch ? urlMatch[1] : null;
  
    const headers = {};
    let headerMatch;
    while ((headerMatch = headersRegex.exec(curlCommand)) !== null) {
      // @ts-ignore
      headers[headerMatch[1]] = headerMatch[2];
    }
  
    const dataMatch = curlCommand.match(dataRegex);
    let body = null;
  
    if (dataMatch) {
      const dataString = dataMatch[2];
      body = {};
      dataString.split('&').forEach(pair => {
        const [key, value] = pair.split('=');
        body[key] = value;
      });
    }
  
    return { url, headers, body };
  }

function LinkAd() {
    const [curl, setCurl] = useState('');
    const [ids, setIds] = useState('');
    const [loading, setLoading] = useState(false);
    var linked = [];
    var codeGetIds = `console.log(Array.from(document.querySelectorAll("#google_ads_sub_customer_id option")).map(o => o.value).filter(v => !!v).join(','))`;
    const link = async () => {
      if(!curl || !ids) {
        return;
      }

      setLoading(true);
      const jsonURL = parseCurl(curl);

      let retry = 0;
      let count = -1;
      let success = 0;
      while(count != 0 && retry <= 10) {
        count=0;
  
        let tasks = [];
        let listId = ids.includes(',') ? ids.split(",") : ids.split('\n');
        listId = listId.filter(id => !linked.includes(id));
        
        for (let i = 0; i < listId.length; i++) {
          let id = listId[i].replaceAll('-', '').trim();
          jsonURL.body.force_link_account = 1;
          jsonURL.body.google_ads_sub_customer_id = id;
    
          let config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: jsonURL.url,
            headers: jsonURL.headers,
            data : Object.keys(jsonURL.body).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(jsonURL.body[key])).join('&')
          };
    
          // @ts-ignore
          let task = axios.request(config)
                    .then((response) => {
                      try {
                        if(response.data.error ==0) {
                          success++;
                          count++;
                          linked.push(id);
                        }
                      } catch (error) {
                        console.error(error);
                      }
                    }).catch((error) => {
                      console.error(error);
                    });
            tasks.push(task);
        }
        await Promise.all(tasks);
        retry++;
      }
      setLoading(false);
      alert(`Link Thành Công: ${success} TK`);
    }
    
    return (
      <div>
        <Button type="primary"  onClick={() => {
          navigator.clipboard.writeText(codeGetIds);
        //   toast({
        //     description: 'Đã copy',
        //     className: 'bg-green-500',
        //   })
        }}>
          Copy Code Lấy DS ID
        </Button>
        
        <div style={{ display: 'flex', gap: 10 }}>
          <TextArea rows={10}
            placeholder='Dán cURL ...'
            onChange={(e) => setCurl(e.target.value)} />
          <TextArea rows={10}
            placeholder='Dán Danh sách ID ...'
            onChange={(e) => setIds(e.target.value)} />
        </div>
        <Button type="primary" loading={loading} onClick={link}>
          Link
        </Button>
      </div>
    )
  }
  export default LinkAd;